import { render, staticRenderFns } from "./ProcessConhecimento.vue?vue&type=template&id=0bf1c140&"
import script from "./ProcessConhecimento.vue?vue&type=script&lang=js&"
export * from "./ProcessConhecimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports